import React, { useEffect, useState } from "react";
import { Item } from "./styledComponent";
import { Grid } from "@mui/material";
import ColorPicker from "./ColorPicker";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import { colorThemeLabels } from "./data";
import { performPostRequest } from "../../../service/network/NetworkService";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { getApiUrl } from "../../../service/network/UrlMapper";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import { notification } from "antd";
import { publishEvent } from "../../../components/generic/EventPublisher";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { useReadMemory } from "../../generic/hooks/useReadMemory";

const ColorSchemeCreation = ({ theme, setTheme, organizationIdentifier }) => {
  const id = React.useId();
  const user = useReadMemory(MemoryType.USER)
  const [themeColors, setThemeColors] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUpdateColors = async (e) => {
    setLoading(true);
    e.preventDefault();
    const configurationValue = {
      ...theme,
      colorScheme: {
        ...theme.colorScheme,
        "main-theme-color": themeColors["main-theme-color"],
        "border-color": themeColors?.["main-theme-color"],
        "patient-volunteer-banner-bg-color": themeColors?.["main-theme-color"],
        "primary-button-color": themeColors?.["main-theme-color"],
        "spinner-bg-color": themeColors?.["main-theme-color"],
        "status-lable-bg-color": themeColors?.["main-theme-color"],
        "tool-tip-bg-color": themeColors?.["main-theme-color"],
        "secondary-theme-color": themeColors?.["secondary-theme-color"],
        "primary-text-color": themeColors?.["primary-text-color"],
        "secondary-text-color": themeColors?.["secondary-text-color"],
        "selected-bg-color": themeColors?.["selected-bg-color"],
        "tool-tip-text-color": themeColors?.["tool-tip-text-color"],
        "text-warning": themeColors?.["text-warning"],
      },
    };

    const payload = {
      intent: "add_configuration",
      payload: {
        configurationKey: "niramaya.organization.theme",
        configurationValue: JSON.stringify(configurationValue),
      },
      context: {
        organizationIdentifier,
      },
    };

    try {
      const response = await performPostRequest(
        getApiUrl()[IntentType.ADD_CONFIGURATION],
        JSON.stringify(payload)
      );
      const result = await response.json();
      const themeValue = JSON.parse(result?.configurationValue || "{}");
      setTheme(themeValue);
      publishEvent("niramaya.organization.colortheme.updated", user, themeValue, theme)
      notification.success({
        message: "Theme color updated successfully!",
        placement: "bottomRight",
      });
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setThemeColors(theme?.colorScheme);
  }, [theme?.colorScheme]);

  return (
    <>
      <Grid container spacing={2} sx={{ paddingBlock: 2 }}>
        <Grid xs={12} item>
          <Item elevation={0}>
            <h6 className="add-edit-patient-sub-header">Choose Theme Color</h6>
          </Item>
        </Grid>

        {colorThemeLabels.map((item) => (
          <Grid xs={12} sm={6} md={4} item key={id + item?.label}>
            <Item elevation={0}>
              <ColorPicker
                label={item?.label}
                colorKey={item?.key}
                themeColors={themeColors}
                setThemeColors={setThemeColors}
              />
            </Item>
          </Grid>
        ))}

        <Grid
          xs={12}
          md={8}
          item
          display="flex"
          alignItems="center"
          justifyContent="end"
        >
          <PrimaryButton
            buttonText="Update Colors"
            handleOnClick={handleUpdateColors}
            loading={loading}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ColorSchemeCreation;
